import { KeyValuePairs, Status, Typography } from '@kc-console/common-ui';
import { getCustomFormatDate } from '@kc-console/core';
import { CopyableText } from '@kc-console/shared-ui';

import type { KeyValuePairsProps } from '@kc-console/common-ui';
import type { EventDetail } from '@/pages/events/model/types';

import {
  getEventStatusLabelMap,
  getEventStatusVariant,
} from '@/pages/events/model/getEventStatusVariant';

const DATE_FORMAT = 'yyyy.MM.dd (EEE) HH:mm';
const EMPTY_VALUE = '-';

interface InfoSectionContentProps {
  event: EventDetail;
}

/**
 * 이벤트 상세 - 세부 정보 섹션.
 * @description
 * - 이벤트, ID(복사 버튼), 상태, 리전, 시작/종료 일시를 2열 KeyValuePairs로 노출한다.
 * @example
 * <InfoSectionContent event={event} />
 */
const InfoSectionContent = ({ event }: InfoSectionContentProps) => {
  const items: KeyValuePairsProps['items'] = [
    {
      label: '이벤트',
      value: <Typography variant="body/normal/md">{event.title || EMPTY_VALUE}</Typography>,
    },
    {
      label: 'ID',
      value: event.eventId ? <CopyableText value={event.eventId} /> : EMPTY_VALUE,
    },
    {
      label: '상태',
      value: event.eventStatus ? (
        <Status status={getEventStatusVariant(event.eventStatus)}>
          {getEventStatusLabelMap()[event.eventStatus] ?? event.eventStatus}
        </Status>
      ) : (
        EMPTY_VALUE
      ),
    },
    {
      label: '리전',
      value: <Typography variant="body/normal/md">{event.region || EMPTY_VALUE}</Typography>,
    },
    {
      label: '시작 일시',
      value: (
        <Typography variant="body/normal/md">
          {event.startDate ? getCustomFormatDate(event.startDate, DATE_FORMAT) : EMPTY_VALUE}
        </Typography>
      ),
    },
    {
      label: '종료 일시',
      value: (
        <Typography variant="body/normal/md">
          {event.endDate ? getCustomFormatDate(event.endDate, DATE_FORMAT) : EMPTY_VALUE}
        </Typography>
      ),
    },
  ];

  return <KeyValuePairs items={items} maxColumnRepeat={2} showDivider showSideMargin />;
};

export default InfoSectionContent;
